<section>
  <span *ngIf="filterValidateMessage" class="filter-validate-message">{{usageLblText.infoMessageLbl}}</span>
  <form [formGroup]="filterUsageHeaderForm">
    <div class="row filter-usage-header-div">
      <div class="form-group filter-usage-header-start-date">
        <label class="lbl" [for]="effectiveFromLBL">{{usageLblText.startDateLbl}}<span class="requiredField">*</span></label>
        <kendo-datepicker formControlName="startDate" class="kendoInput" name="effectiveFrom"
                          placeholder="MM/DD/YYYY"
                          #effectiveFromLBL format="MM/dd/yyyy"
                          [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}">
        </kendo-datepicker>
      </div>
      <div class="form-group filter-usage-header-start-date">
        <label class="lbl" [for]="effectiveToLBL">{{usageLblText.endDateLbl}}<span class="requiredField">*</span></label>
        <kendo-datepicker formControlName="endDate" class="kendoInput" name="effectiveTo"
                          placeholder="MM/DD/YYYY"
                          #effectiveToLBL format="MM/dd/yyyy"
                          [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}">
        </kendo-datepicker>
      </div>
      <div class="form-group filter-usage-header-start-date" *ngIf="getSampleRegion">
        <label class="lbl">{{usageLblText.regionLbl}}</label>
        <kendo-dropdownlist class="kendoInput usage-region-report-dropdown"
                            formControlName="region"
                            [data]="getSampleRegion"
                            [textField]="'regionDescription'"
                            [valueField]="'regionCode'" [ngModel]="{regionDescription:selectedRegionDescription,regionCode:selectedRegionCode}">
        </kendo-dropdownlist>
      </div>
      <div class="form-group filter-usage-header-start-date" >
        <label class="lbl" [for]="inactiveUsageItem">{{usageLblText.displayInactiveLbl}}</label>
        <input type="checkbox" class="k-checkbox checkboxSize" #inactiveUsageItem [checked]="isInActiveUsage" (change)="filterInActiveUsageItems($event)" />
      </div>
      <div class="form-group">
        <button kendoButton [disabled]="filterSaveInProcess" class="btn dialogBtnSize filter-date-btn"
                (click)="getFilterUsageHeader()">
          {{usageLblText.filterlbl}}<kendo-loader *ngIf="filterSaveInProcess" style="color:blue"></kendo-loader>
        </button>
      </div>
    </div>
  </form>
</section>

<section>
  <kendo-grid [data]="usageHeaderGridData"
              class="usagerSelectionGridCls"
              [sortable]="true"
              [selectable]="false"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="usageGridstate.sort"
              [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
              [pageSize]="usageGridstate.take"
              [skip]="usageGridstate.skip"
              [columnMenu]="{ filter: false, sort: false }"
              (sort)="usageHeaderGridSortChange($event)"
              (pageChange)="usageHeaderGridPageChange($event)"
             
              (dataStateChange)="usageHeaderGridDataStateChange($event)"
              [filter]="usageGridSettings.state.filter"
              [loading]="usageLoading">

     <!--(columnReorder)="onReorder($event)"
 (columnVisibilityChange)="onVisibilityChange($event)"-->

    <ng-template kendoGridToolbarTemplate>
      <div class="k-grid-toolbar-button-display btn-web">
        <button kendoButton class="excel-button " icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()">
          {{usageLblText.exportToExcelLbl}}
          <kendo-loader *ngIf="loadingExcel"></kendo-loader>
        </button>
        <button kendoButton icon="file-pdf" class="pdf-button " [disabled]="loadingPDF" (click)="generatePDF()">
          {{usageLblText.exportToPDFLbl}}
          <kendo-loader *ngIf="loadingPDF"></kendo-loader>
        </button>
      </div>
    </ng-template>
    <kendo-grid-column *ngFor="let col of usageGridSettings.columnsConfig" [headerClass]="'wrapheader-sample-admin-grid'"
                       [field]="col.field"
                       [title]="col.title"
                       [width]="col._width"
                       [filter]="col.filter"
                       [filterable]="col.filterable"
                       [hidden]="col.hidden"
                       [format]="col.format" media="(min-width: 1025px)">
      <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'totalCost'">
        {{dataItem.totalCost | currency}}
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field == 'isActive'">
        <kendo-switch [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'" [disabled]="true"
                      [offLabel]="'No'">
        </kendo-switch>
      </ng-template>
      
    </kendo-grid-column>

    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>
  </kendo-grid>
</section>
